import script from "./LoginForm.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginForm.vue?vue&type=script&setup=true&lang=js"

import "./LoginForm.vue?vue&type=style&index=0&id=c8fd749a&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8fd749a"]])

export default __exports__